import { connect } from 'react-redux';
import { getTranslationModule } from '../../languages';
import { addOrdinalSuffix } from '../../common/utils';

const numericLabel = 'numeric';
const formatDateTime = function ({
  language,
  dateObjectParams,
  format = { month: 'short', day: numericLabel }
}) {
  const {
    year,
    month,
    day
  } = format;

  const passedDate = new Date(dateObjectParams);

  if (Number.isNaN(passedDate.getTime())) {
    console.warn('Invalid date object param passsed to "formatDateTime":', dateObjectParams);
  }

  let localizedDate = new Intl
    .DateTimeFormat(language, format)
    .format(passedDate);

  if (!!day && !(year === numericLabel && month === numericLabel && day === numericLabel)) {
    const placeholderPredictableDay = '13';
    const predictableDate = new Date(`2000-${passedDate.getMonth() + 1}-${placeholderPredictableDay}`);
    const localizedPredictableDate = new Intl
      .DateTimeFormat(language, format)
      .format(predictableDate);

    const passedDay = new Intl
      .DateTimeFormat(language, { day: format.day })
      .format(passedDate);

    const indexOfDay = localizedPredictableDate.indexOf(placeholderPredictableDay);
    const lengthOfDay = passedDay.length;
    const ordinalDay = addOrdinalSuffix(passedDate.getDate(), language);
    localizedDate = localizedDate.substr(0, indexOfDay) + ordinalDay + localizedDate.substr(
      indexOfDay + lengthOfDay
    );
  }

  return localizedDate;
};

const translate = function ({
  language,
  message,
  replacements,
  translationObject,
  isMultipleModulePath
}) {
  let translatedText;

  if (isMultipleModulePath) {
    const explodedTranslationId = message.split('/');

    if (explodedTranslationId.length !== 2) {
      throw new Error(
        `Invalid translation message format!
        Provide the submodule name in front of the translation id (message)
        separated by "/" (e.g. "header/header-item-translation", passed: ${message})`
      );
    }

    const moduleName = explodedTranslationId[0];

    if (!translationObject[moduleName]) {
      console.error(
        'translation module:', translationObject,
        'passed submodule name:', moduleName,
        'imported submodules:', Object.keys(translationObject)
      );
      throw new Error(
        `submodule name "${moduleName}" could not be found in the provided translation module - 
        perhaps its not imported or the module does not exist in the "${language}" translation file`
      );
    }

    const translationId = explodedTranslationId[1];
    translatedText = translationObject[moduleName][translationId];
  }

  else {
    translatedText = translationObject[message];
  }

  if (!translatedText) {
    if (translatedText !== '') {
      console.error(
        `Translation for message "${message}" could not be found`,
        'translation module:', translationObject,
        'message:', message
      );

      return message;
      // throw new Error(`Translation for message "${message}" could not be found`);
    }

    // console.warn(`Message "${message}" is not translated yet.`, 'Translation module:', translationObject);
  }

  if (replacements) {
    return translatedText.replace(/{(.+?)}/g, (match, captured) => replacements[captured] || '');
  }

  return translatedText;
};

const getUsedTranslationModules = function ({
  language,
  isMultipleModulePath,
  dictionaryNestingPath
}) {
  let translationObject = {};

  if (isMultipleModulePath) {
    if (!Array.isArray(dictionaryNestingPath)) {
      throw new Error('ERROR: array of nesting path strings are expected if "isMultipleModulePath" is true');
    }

    dictionaryNestingPath.forEach(singlePath => {
      const explodedPath = singlePath.split('/');
      const moduleName = explodedPath[explodedPath.length - 1];
      translationObject[moduleName] = getTranslationModule(singlePath, language);
    });
  }

  else {
    translationObject = getTranslationModule(dictionaryNestingPath, language);
  }

  if (!translationObject) {
    throw new Error(
      `Could not find translation module in the provided path "${dictionaryNestingPath}"`
    );
  }

  return translationObject;
};

const withLocalization = (WrappedComponent, dictionaryNestingPath = '') => {
  const isMultipleModulePath = Array.isArray(dictionaryNestingPath);

  return connect(({ language }) => ({
    language,
    formatDateTime: (dateObjectParams, format) => formatDateTime({
      language,
      format,
      dateObjectParams
    }),
    translate: (message, replacements) => translate({
      language,
      message,
      replacements,
      isMultipleModulePath,
      translationObject: getUsedTranslationModules({
        language,
        isMultipleModulePath,
        dictionaryNestingPath
      })
    })
  }))(WrappedComponent);
};

export default withLocalization;
export {
  formatDateTime,
  translate,
  getUsedTranslationModules
};